/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

export const filterTourByTourTime = ({ tour, filteredTourTimes }) =>
    !!filteredTourTimes[tour.tour_id];

export const filterTimesBySelectedTimes = ({ tourTimesById, tourTimeFilter }) => {
    if (
        isEmpty(tourTimesById) ||
        isEmpty(tourTimeFilter) ||
        (!tourTimeFilter.earlyMorning &&
            !tourTimeFilter.morning &&
            !tourTimeFilter.earlyAfternoon &&
            !tourTimeFilter.afternoon &&
            !tourTimeFilter.evening &&
            !tourTimeFilter.lateNight)
    ) {
        return tourTimesById;
    }

    const newTourTimeById = {};
    for (const tourId in tourTimesById) {
        if (tourTimesById.hasOwnProperty(tourId)) {
            const times = tourTimesById[tourId].filter((time) =>
                filterByTimeSection(moment(time.displayTime, 'LT'), tourTimeFilter)
            );

            if (!isEmpty(times)) {
                newTourTimeById[tourId] = times;
            }
        }
    }

    return newTourTimeById;
};

function filterByTimeSection(date, tourTimeFilter) {
    if (tourTimeFilter.earlyMorning && timeIsEarlyMorning(date)) {
        return true;
    }
    if (tourTimeFilter.morning && timeIsMorning(date)) {
        return true;
    }
    if (tourTimeFilter.earlyAfternoon && timeIsEarlyAfternoon(date)) {
        return true;
    }
    if (tourTimeFilter.afternoon && timeIsAfternoon(date)) {
        return true;
    }
    if (tourTimeFilter.evening && timeIsEvening(date)) {
        return true;
    }
    if (tourTimeFilter.lateNight && timeIsLateNight(date)) {
        return true;
    }
    return false;
}

function timeIsEarlyMorning(date) {
    const dateStart = moment('00:00 AM', 'LT');
    const dateEnd = moment('07:59 AM', 'LT');
    return date.isSameOrAfter(dateStart) && date.isSameOrBefore(dateEnd);
}

function timeIsMorning(date) {
    const dateStart = moment('08:00 AM', 'LT');
    const dateEnd = moment('11:59 AM', 'LT');
    return date.isSameOrAfter(dateStart) && date.isSameOrBefore(dateEnd);
}

function timeIsEarlyAfternoon(date) {
    const dateStart = moment('12:00 PM', 'LT');
    const dateEnd = moment('02:59 PM', 'LT');
    return date.isSameOrAfter(dateStart) && date.isSameOrBefore(dateEnd);
}

function timeIsAfternoon(date) {
    const dateStart = moment('03:00 PM', 'LT');
    const dateEnd = moment('05:59 PM', 'LT');
    return date.isSameOrAfter(dateStart) && date.isSameOrBefore(dateEnd);
}

function timeIsEvening(date) {
    const dateStart = moment('06:00 PM', 'LT');
    const dateEnd = moment('08:59 PM', 'LT');
    return date.isSameOrAfter(dateStart) && date.isSameOrBefore(dateEnd);
}

function timeIsLateNight(date) {
    const dateStart = moment('09:00 PM', 'LT');
    const dateEnd = moment('11:59 PM', 'LT');
    return date.isSameOrAfter(dateStart) && date.isSameOrBefore(dateEnd);
}
